var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', [_c('div', {
    staticClass: "card card-custom gutter-b",
    staticStyle: {
      "box-shadow": "none"
    }
  }, [_c('div', {
    staticClass: "card-header card-header-tabs-line"
  }, [_c('ul', {
    ref: "builder-tab",
    staticClass: "nav nav-dark nav-bold nav-tabs nav-tabs-line",
    attrs: {
      "role": "tablist"
    }
  }, [_vm._m(0)])]), _c('b-form', {
    staticClass: "form",
    on: {
      "submit": function submit($event) {
        $event.stopPropagation();
        $event.preventDefault();
        return _vm.onSubmit.apply(null, arguments);
      }
    }
  }, [_c('div', {
    staticClass: "card-body"
  }, [_c('b-tabs', {
    staticClass: "hide-tabs",
    model: {
      value: _vm.tabIndex,
      callback: function callback($$v) {
        _vm.tabIndex = $$v;
      },
      expression: "tabIndex"
    }
  }, [_c('b-tab', {
    attrs: {
      "active": ""
    }
  }, [_c('b-row', [_c('b-col', {
    attrs: {
      "md": "6"
    }
  }, [_c('b-form-group', {
    attrs: {
      "id": "nome",
      "label-for": "nome",
      "label": "Nome *"
    }
  }, [_c('b-form-input', {
    attrs: {
      "id": "nome",
      "state": _vm.validateState('nome'),
      "maxlength": "50",
      "autofocus": ""
    },
    model: {
      value: _vm.$v.form.nome.$model,
      callback: function callback($$v) {
        _vm.$set(_vm.$v.form.nome, "$model", $$v);
      },
      expression: "$v.form.nome.$model"
    }
  })], 1)], 1), _c('b-col', {
    attrs: {
      "md": "3"
    }
  }, [_c('b-form-group', {
    attrs: {
      "id": "cpf",
      "label-for": "cpf",
      "label": "CPF"
    }
  }, [_c('b-form-input', {
    directives: [{
      name: "mask",
      rawName: "v-mask",
      value: ['###.###.###-##'],
      expression: "['###.###.###-##']"
    }],
    attrs: {
      "id": "cpf",
      "maxlength": "14"
    },
    model: {
      value: _vm.form.cpf,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "cpf", $$v);
      },
      expression: "form.cpf"
    }
  })], 1)], 1), _c('b-col', {
    attrs: {
      "md": "3"
    }
  }, [_c('b-form-group', {
    attrs: {
      "id": "rg",
      "label-for": "rg",
      "label": "RG"
    }
  }, [_c('b-form-input', {
    attrs: {
      "id": "rg",
      "maxlength": "20"
    },
    model: {
      value: _vm.form.rg,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "rg", $$v);
      },
      expression: "form.rg"
    }
  })], 1)], 1)], 1), _c('b-row', [_c('b-col', {
    attrs: {
      "md": "6"
    }
  }, [_c('b-form-group', {
    attrs: {
      "id": "email",
      "label-for": "email",
      "label": "E-mail"
    }
  }, [_c('b-form-input', {
    attrs: {
      "id": "email",
      "state": _vm.validateState('email'),
      "type": "email",
      "maxlength": "255"
    },
    model: {
      value: _vm.$v.form.email.$model,
      callback: function callback($$v) {
        _vm.$set(_vm.$v.form.email, "$model", $$v);
      },
      expression: "$v.form.email.$model"
    }
  })], 1)], 1), _c('b-col', {
    attrs: {
      "md": "3"
    }
  }, [_c('b-form-group', {
    attrs: {
      "id": "telefone",
      "label-for": "telefone",
      "label": "Telefone"
    }
  }, [_c('b-form-input', {
    directives: [{
      name: "mask",
      rawName: "v-mask",
      value: ['(##) #### ####', '(##) # #### ####'],
      expression: "['(##) #### ####', '(##) # #### ####']"
    }],
    attrs: {
      "id": "telefone",
      "maxlength": "30"
    },
    model: {
      value: _vm.form.telefone,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "telefone", $$v);
      },
      expression: "form.telefone"
    }
  })], 1)], 1), _c('b-col', {
    attrs: {
      "md": "3"
    }
  }, [_c('b-form-group', {
    attrs: {
      "id": "status",
      "label-for": "status",
      "label": "Ativo"
    }
  }, [_c('span', {
    staticClass: "switch switch-icon"
  }, [_c('label', [_c('input', {
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "value": true,
      "checked": _vm.form.status == true
    },
    on: {
      "change": _vm.setAtivo
    }
  }), _c('span')])])])], 1)], 1), _c('div', {
    staticClass: "separator separator-dashed my-6"
  }), _c('h5', {
    staticClass: "font-weight-bold text-dark mb-5"
  }, [_vm._v("Endereço")]), _c('b-row', [_c('b-col', {
    attrs: {
      "md": "3"
    }
  }, [_c('b-form-group', {
    attrs: {
      "id": "cep",
      "label-for": "cep",
      "label": "CEP"
    }
  }, [_c('b-form-input', {
    directives: [{
      name: "mask",
      rawName: "v-mask",
      value: ['#####-###'],
      expression: "['#####-###']"
    }],
    attrs: {
      "id": "cep",
      "maxlength": "9"
    },
    model: {
      value: _vm.form.cep,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "cep", $$v);
      },
      expression: "form.cep"
    }
  })], 1)], 1), _c('b-col', {
    attrs: {
      "md": "2"
    }
  }, [_c('button', {
    staticClass: "btn btn-primary font-weight-bold consultar-cep",
    attrs: {
      "type": "button",
      "disabled": _vm.consultandoCep
    },
    on: {
      "click": _vm.consultaCep
    }
  }, [_vm.consultandoCep ? _c('span', {
    staticClass: "spinner spinner-sm spinner-light mr-2"
  }) : _vm._e(), _vm._v(" Consultar CEP ")])]), _c('b-col', {
    attrs: {
      "md": "5"
    }
  }, [_c('b-form-group', {
    attrs: {
      "id": "logradouro",
      "label-for": "logradouro",
      "label": "Logradouro"
    }
  }, [_c('b-form-input', {
    attrs: {
      "id": "logradouro",
      "maxlength": "100"
    },
    model: {
      value: _vm.form.logradouro,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "logradouro", $$v);
      },
      expression: "form.logradouro"
    }
  })], 1)], 1), _c('b-col', {
    attrs: {
      "md": "2"
    }
  }, [_c('b-form-group', {
    attrs: {
      "id": "numero",
      "label-for": "numero",
      "label": "Número"
    }
  }, [_c('b-form-input', {
    attrs: {
      "id": "numero",
      "maxlength": "100"
    },
    model: {
      value: _vm.form.numero,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "numero", $$v);
      },
      expression: "form.numero"
    }
  })], 1)], 1)], 1), _c('b-row', [_c('b-col', {
    attrs: {
      "md": "4"
    }
  }, [_c('b-form-group', {
    attrs: {
      "id": "bairro",
      "label-for": "bairro",
      "label": "Bairro"
    }
  }, [_c('b-form-input', {
    attrs: {
      "id": "bairro",
      "maxlength": "100"
    },
    model: {
      value: _vm.form.bairro,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "bairro", $$v);
      },
      expression: "form.bairro"
    }
  })], 1)], 1), _c('b-col', {
    attrs: {
      "md": "4"
    }
  }, [_c('b-form-group', {
    attrs: {
      "id": "complemento",
      "label-for": "complemento",
      "label": "Complemento"
    }
  }, [_c('b-form-input', {
    attrs: {
      "id": "complemento",
      "maxlength": "100"
    },
    model: {
      value: _vm.form.complemento,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "complemento", $$v);
      },
      expression: "form.complemento"
    }
  })], 1)], 1), _c('b-col', {
    attrs: {
      "md": "4"
    }
  }, [_c('b-form-group', {
    attrs: {
      "id": "cidade",
      "label-for": "cidade",
      "label": "Cidade"
    }
  }, [_c('VueSelect', {
    attrs: {
      "id": "cidade",
      "label": "cidade",
      "options": _vm.cidades
    },
    on: {
      "input": _vm.setCidade,
      "search": _vm.onSearchCidade
    },
    scopedSlots: _vm._u([{
      key: "option",
      fn: function fn(option) {
        return [_vm._v(" " + _vm._s(option.cidade + " - " + option.uf) + " ")];
      }
    }, {
      key: "selected-option",
      fn: function fn(option) {
        return [_vm._v(" " + _vm._s(option.cidade + " - " + option.uf) + " ")];
      }
    }]),
    model: {
      value: _vm.form.cidade,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "cidade", $$v);
      },
      expression: "form.cidade"
    }
  }, [_c('template', {
    slot: "no-options"
  }, [_vm._v(" Informe o nome da cidade ")])], 2)], 1)], 1)], 1)], 1)], 1)], 1), _c('div', {
    staticClass: "card-footer"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-12",
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('button', {
    ref: "submit_vendedor_novo",
    staticClass: "btn btn-primary font-weight-bold",
    attrs: {
      "type": "submit"
    }
  }, [_vm._v(" Salvar ")]), _c('router-link', {
    staticClass: "btn btn-clean font-weight-bold",
    attrs: {
      "to": {
        name: 'vendedorLista'
      }
    }
  }, [_vm._v(" Cancelar ")])], 1)])])])], 1)]);
};
var staticRenderFns = [function () {
  var _vm = this,
    _c = _vm._self._c;
  return _c('li', {
    staticClass: "nav-item"
  }, [_c('a', {
    staticClass: "nav-link active",
    attrs: {
      "data-tab": "0",
      "data-toggle": "tab",
      "href": "#",
      "role": "tab"
    }
  }, [_vm._v(" Cadastro ")])]);
}];
export { render, staticRenderFns };